export default "__VITE_ASSET__Do_e$4tP__"